export const info = {
  dashboardOrg: {
    text: '¿Cómo hacer que los  ejecutores reporten a través de esta plataforma?',
    howto:
      "Selecciona 'Ver Reporte' o busca una licitación en la barra de búsqueda. Si ya existe un proyecto asociado te llevaremos a el, si no se abrirá un formulario para solicitar uno nuevo.",
  },
  projectPetition: {
    text: '¿Cómo hacer que los  ejecutores reporten a través de esta plataforma?',
    howto:
      'Al completar este formulario, se enviará un correo electrónico a los ejecutores con un link para que puedan reportar sus avances.',
  },
};
